import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  Switch,
  Tooltip,
} from "@material-ui/core";
import { useContext, useEffect, useMemo, useState, useCallback } from "react";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Btn from "../../../../components/buttons/Btn";
import TableDefault from "../../../../components/grid/TableDefault";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import { Header } from "../styles/GerenciamentoContrato";
import Chip from "./../../../../components/basics/Chip";
import InputRadio from "./../../../../components/inputs/InputRadio";
import MaskService from "./../../../../utils/mask/maskService";
import { ConfigurationContext } from "../contexts/ConfigurationContext";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import { EditOutlined, BrushSharp } from "@material-ui/icons";
import useGerenciamentoContratoListagemController from "./../controllers/GerenciamentoContratoListagemController";
import { notify } from "./../../../../utils/notify";
import SearchDialog from "./../../../../patterns/modals/SearchDialog";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";

import ModalEditHistoric from "../children/ModalEditHistoric";
import moment from "moment";
import { findContratoServico } from "../../../../repositories/qerpapi/erp/faturamento/ContratoServicoRepository";
import { GlobalVariables } from "../../../../GlobalVariables";
import SelectErp from "../../../../components/basics/SelectErp";

const ModalEdicaoFinanceiro = ({
  open,
  contractData = null,
  setOpen,
  makeRequestAgain,
  setLoading = () => {},
}) => {
  const { queryParams } = useContext(QueryParamsContext);
  const { configuration } = useContext(ConfigurationContext);
  const contractDecimals = useMemo(
    () => configuration?.contract_decimal_size || 2,
    [configuration]
  );

  const {
    getContasReceberByContract,
    handleSelectedService,
    handleSelectedExpenseService,
    handleSelectedExpenses,
    handleSubmitByButton,
    findLogsInvoiceByIdCr,
  } = useGerenciamentoContratoListagemController();

  const [errors, setErrors] = useState({});
  const [crRows, setCrRows] = useState([]);
  const [selectedAction, setSelectedAction] = useState({
    label: "Abatimento",
    value: "A",
  });
  const [openSearchServices, setOpenSearchServices] = useState(false);
  const [openSearchExpenses, setOpenSearchExpenses] = useState(false);
  const [openSearchExpenseServices, setOpenSearchExpenseServices] =
    useState(false);

  const [modalViewHistoric, setModalViewHistoric] = useState(false);
  const [editHistoric, setEditHistoric] = useState(null);

  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [userValue, setUserValue] = useState("0,00");
  const [isPercentage, setIsPercentage] = useState(false);
  const [reason, setReason] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [service, setService] = useState(null);
  const [expenseService, setExpenseService] = useState(null);
  const [expense, setExpense] = useState(null);
  const [complement, setComplement] = useState("");
  const [serviceList, setServiceList] = useState([]);

  const { id, numero, nfse } = contractData;

  // eslint-disable-next-line no-unused-vars
  const [listSituation, setListSituation] = useState([
    { value: "0", label: "Todos" },
    { value: "1", label: "Aberto" },
    { value: "2", label: "Vencido" },
    { value: "3", label: "Liquidado" },
    { value: GlobalVariables.RecieveSituations.inWallet, label: "Em Carteira" },
    { value: GlobalVariables.RecieveSituations.inCharge, label: "Em Cobrança" },
    {
      value: GlobalVariables.RecieveSituations.inNotaryOffice,
      label: "Em Cartorio",
    },
    {
      value: GlobalVariables.RecieveSituations.protest,
      label: "Protestado",
    },
    {
      value: GlobalVariables.RecieveSituations.partiallyLiquidated,
      label: "Liquidado Parcialmente",
    },
    {
      value: GlobalVariables.RecieveSituations.fullyLiquidated,
      label: "Liquidado Totalmente",
    },
    {
      value: GlobalVariables.RecieveSituations.factoring,
      label: "Desconto de Título - Factoring",
    },
    { value: GlobalVariables.RecieveSituations.loaded, label: "Baixado" },
    {
      value: GlobalVariables.RecieveSituations.dealing,
      label: "Depto Jurídico - Negociando",
    },
    { value: GlobalVariables.RecieveSituations.canceled, label: "Cancelado" },
    {
      value: GlobalVariables.RecieveSituations.renegotiated,
      label: "Renegociado",
    },
    {
      value: GlobalVariables.RecieveSituations.creditRecovery,
      label: "Recup. Crédito",
    },
    { value: GlobalVariables.RecieveSituations.suspended, label: "Suspenso" },
    {
      value: GlobalVariables.RecieveSituations.waitingLoaded,
      label: "Aguardando Baixa",
    },
    {
      value: GlobalVariables.RecieveSituations.returnToBank,
      label: "Devolvido Banco",
    },
  ]);
  const [situation, setSituation] = useState({
    label: "Em Carteira",
    value: GlobalVariables.RecieveSituations.inWallet,
  });

  const [initialFilterDate, setInitialFilterDate] = useState(null);
  const [finalFilterDate, setFinalFilterDate] = useState(null);

  const handleClickButton = (context) => {
    handleSubmitByButton(
      context,
      {
        id,
        userValue,
        selectedAccounts,
        selectedAction,
        isPercentage,
        reason,
        quantity,
        service,
        expense,
        expenseService,
        complement,
      },
      {
        setSelectedAccounts,
        setUserValue,
        setIsPercentage,
        setReason,
        setQuantity,
        setService,
        setErrors,
        setCrRows,
        setLoading,
        setExpense,
        setExpenseService,
        setComplement,
      }
    );
  };

  // Layout quando operação selecionada é Reajuste/Abatimento
  const readjustLayout = () => (
    <>
      <Grid item xs={4}>
        <TextFieldErp
          variant="filled"
          label={`Valor ${isPercentage ? "(%)" : "(R$)"}`}
          value={userValue}
          setValue={setUserValue}
          mask="decimal"
          error={!!errors.value}
          helperText={errors.value || ""}
        />
      </Grid>
      <Grid item xs={4} style={{ display: "flex", alignItems: "center" }}>
        <FormControlLabel
          control={
            <Switch
              checked={isPercentage}
              onChange={() => setIsPercentage(!isPercentage)}
              name="check"
            />
          }
          label="Porcentagem"
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldErp
          label="Motivo"
          maxLength={200}
          multiline
          variant="filled"
          rows={3}
          value={reason}
          setValue={setReason}
        />
      </Grid>
      <Grid item>
        <Btn label="Aplicar" onClick={() => handleClickButton("readjust")} />
      </Grid>
    </>
  );

  // Layout quando a operação é adicionar um serviço avulso.
  const addServiceLayout = () => (
    <>
      <Grid item xs={10}>
        <SearchSelect
          variant="filled"
          label="Serviço"
          value={service}
          setValue={setService}
          error={!!errors.service}
          helperText={errors.service || ""}
          route="faturamento/contratos/v1/contrato-servicos-empresa"
          rawUrl={`servico_tipo=A&empresa_id=${queryParams.empresa_id}`}
          filter="descricao"
        />
      </Grid>
      <Grid item xs={2}>
        <Btn
          onClick={() => setOpenSearchServices(true)}
          label={<SearchIcon />}
          full="true"
        />
      </Grid>
      <Grid item xs={4}>
        <TextFieldErp
          mask="decimal"
          decimals={contractDecimals}
          variant="filled"
          label="Valor (R$)"
          value={userValue}
          setValue={setUserValue}
          error={!!errors.value}
          helperText={errors.value || ""}
        />
      </Grid>
      <Grid item xs={3}>
        <TextFieldErp
          variant="filled"
          label="Qtd."
          value={quantity}
          setValue={setQuantity}
          type="number"
          InputProps={{
            min: 1,
          }}
        />
      </Grid>
      <Grid item xs={4} />
      <Grid item>
        <Btn
          onClick={() => handleClickButton("addService")}
          label="Adicionar"
        />
      </Grid>
    </>
  );

  //Layout quando a operação for Despesas Reembolsáveis
  const addReimbursableExpenses = () => (
    <>
      <Grid item xs={6} md={8}>
        <SearchSelect
          variant="filled"
          label="Despesas"
          value={expense}
          setValue={setExpense}
          error={!!errors.expense}
          helperText={errors.value || ""}
          route="faturamento/despesas-reembolsaveis/v1/empresa"
          rawUrl={`ativo=1&empresa_id=${queryParams.empresa_id}`}
          filter="descricao"
        />
      </Grid>
      <Grid item xs={2}>
        <Btn
          onClick={() => setOpenSearchExpenses(true)}
          label={<SearchIcon />}
          full="true"
        />
      </Grid>
      {nfse === 1 && (
        <Grid item xs={8}>
          <SelectErp
            variant="filled"
            label="Serviço"
            descriptionField="descricao"
            value={expenseService}
            setValue={setExpenseService}
            optionsList={serviceList.filter((s) => s.tiposervico === "A")}
          />
        </Grid>
      )}
      <Grid item xs={4}>
        <TextFieldErp
          mask="decimal"
          variant="filled"
          label="Valor (R$)"
          value={userValue}
          setValue={setUserValue}
          error={!!errors.value}
          helperText={errors.value || ""}
        />
      </Grid>
      <Grid
        item
        xs={4}
        md={8}
        style={{ display: "flex", alignItems: "center" }}
      ></Grid>
      <Grid item>
        <Btn label="Adicionar" onClick={() => handleClickButton("despesas")} />
      </Grid>
    </>
  );

  const views = {
    A: readjustLayout(),
    add: addServiceLayout(),
    dp: addReimbursableExpenses(),
  };

  const editViewHistoric = async (item) => {
    let historic = await findLogsInvoiceByIdCr(item?.id);

    if (historic) {
      setEditHistoric(historic);
      setModalViewHistoric(true);
    }
  };

  const handleClear = () => {
    setInitialFilterDate(null);
    setFinalFilterDate(null);
  };

  const fetchServiceList = useCallback(async () => {
    try {
      const res = await findContratoServico({
        empresa_cnpj: queryParams?.empresa_cnpj,
      });
      if (res.success) {
        setServiceList(res.data);
      } else {
        notify(
          "Aviso: Não foi possível carregar a lista de serviços.",
          false,
          "warning"
        );
      }
    } catch (error) {
      console.error(error);
      notify(
        "Erro ao buscar lista de serviços. Tente novamente.",
        false,
        "warning"
      );
    }
  }, [queryParams?.empresa_cnpj]);

  // Pega a lista com os contas a receber baseado no ID do contrato
  useEffect(() => {
    if (!id) return;

    getContasReceberByContract(id, setCrRows, setLoading);
  }, [id, getContasReceberByContract, setLoading]);

  useEffect(() => {
    if (!queryParams?.empresa_cnpj) return;

    fetchServiceList();
  }, [queryParams?.empresa_cnpj, fetchServiceList]);

  // Sempre que a operação selecionada é trocada, reseta os erros e o valor
  // caso não tenha uma ação selecionada, seta o Reajuste como padrão.
  useEffect(() => {
    if (!selectedAction)
      setSelectedAction({
        label: "Abatimento",
        value: "A",
      });

    setErrors({});
    setUserValue(`0,00`);
  }, [selectedAction, contractDecimals]);

  // Caso a quantidade seja zerada, seta o padrão como 1.
  useEffect(() => {
    if (!quantity) setQuantity(1);
  }, [quantity]);

  // Caso o valor seja esvaziado, seta o mesmo como "0,00"
  useEffect(() => {
    if (!userValue)
      setUserValue(
        selectedAction?.value === "add"
          ? `0,${"0".repeat(contractDecimals)}`
          : `0,00`
      );
  }, [userValue, isPercentage, contractDecimals, selectedAction]);

  useEffect(() => {
    if (service?.valor)
      setUserValue(
        MaskService.toMask(
          "decimal",
          parseFloat(service.valor || "0.00").toFixed(contractDecimals),
          contractDecimals
        )
      );
  }, [service, contractDecimals]);

  // useEffect que ouve as contas a receber selecionadas e o valor digitado pelo usuário
  // caso o valor seja maior do que algum valor de contas a receber selecionado
  // ele o reseta, pois foi conversado com o PO e o máximo de abatimento
  // possível é o próprio valor do contas.
  useEffect(() => {
    const unmaskedValue = MaskService.removeMaskDecimal(userValue);

    if (isPercentage && unmaskedValue > 100 && selectedAction.value === "A") {
      setUserValue(`0,00`);
      notify("O valor do abatimento não pode ser maior que 100%.");
    }

    if (!isPercentage && selectedAction.value === "A") {
      selectedAccounts.forEach((account) => {
        if (unmaskedValue > parseFloat(account.valordocto)) {
          setUserValue(`0,00`);
          notify(
            `O valor selecionado para abatimento é maior do que o valor da Conta a Receber de ID ${account.id}.`
          );
        }
      });
    }
  }, [
    userValue,
    isPercentage,
    selectedAction,
    selectedAccounts,
    contractDecimals,
  ]);

  useEffect(() => {
    if (!expense) {
      setExpenseService(null);
      return;
    }

    if (expense.servico && serviceList.length > 0) {
      const linkedService = serviceList.find(
        (s) => s.id === expense.servico && s.tiposervico === "A"
      );
      setExpenseService(linkedService || null);
    }
  }, [expense, serviceList]);

  return (
    <>
      {modalViewHistoric && (
        <ModalEditHistoric
          open={modalViewHistoric}
          content={editHistoric}
          setContent={setEditHistoric}
          setOpen={setModalViewHistoric}
          setCrRows={setCrRows}
        />
      )}

      {openSearchServices && (
        <SearchDialog
          open={openSearchServices}
          setOpen={setOpenSearchServices}
          columns={[
            { label: "CÓD", id: "id" },
            { label: "Descrição", id: "descricao" },
            {
              label: "Valor",
              id: "valor",
              format: (item) =>
                `R$ ${MaskService.toMask(
                  "decimal",
                  parseFloat(item.valor || 0).toFixed(contractDecimals),
                  contractDecimals
                )}`,
            },
          ]}
          multiSelect={false}
          handleMainClick={(setOpen, selected) =>
            handleSelectedService(setOpen, selected, setService)
          }
          route="faturamento/contratos/v1/contrato-servicos-empresa"
          rawUrl={`servico_tipo=A&empresa_id=${queryParams.empresa_id}`}
          filter="descricao"
          title="CLASSIFICAÇÃO DO SERVIÇO"
        />
      )}

      {openSearchExpenses && (
        <SearchDialog
          open={openSearchExpenses}
          setOpen={setOpenSearchExpenses}
          columns={[
            { label: "CÓD", id: "id" },
            { label: "Descrição", id: "descricao" },
            {
              label: "Serviço",
              id: "servico",
              format: (item) =>
                serviceList.find((s) => s.id === item.servico)?.descricao ||
                item.servico,
            },
          ]}
          multiSelect={false}
          handleMainClick={(setOpen, selected) =>
            handleSelectedExpenses(setOpen, selected, setExpense)
          }
          route="faturamento/despesas-reembolsaveis/v1/empresa"
          rawUrl={`where[ativo]=1&empresa_id=${queryParams.empresa_id}`}
          title="Despesas Reembolsáveis"
        />
      )}

      {openSearchExpenseServices && (
        <SearchDialog
          open={openSearchExpenseServices}
          setOpen={setOpenSearchExpenseServices}
          columns={[
            { label: "CÓD", id: "id" },
            { label: "Descrição", id: "descricao" },
            {
              label: "Valor",
              id: "valor",
              format: (item) =>
                `R$ ${MaskService.toMask(
                  "decimal",
                  parseFloat(item.valor || 0).toFixed(contractDecimals),
                  contractDecimals
                )}`,
            },
          ]}
          multiSelect={false}
          handleMainClick={(setOpen, selected) =>
            handleSelectedExpenseService(setOpen, selected, setExpenseService)
          }
          route="faturamento/contratos/v1/contrato-servicos-empresa"
          rawUrl={`servico_tipo=A&empresa_id=${queryParams.empresa_id}`}
          filter="descricao"
          title="CLASSIFICAÇÃO DO SERVIÇO"
        />
      )}
      <Dialog
        open={open}
        fullScreen
        onClose={(e, reason) => {
          if (reason === "backdropClick") return;
        }}
      >
        <DialogTitle id="dialog-title">
          <Header>
            <Grid
              container
              style={{ width: "100%" }}
              align="center"
              justifyContent="center"
            >
              <Chip
                bgcolor="tertiary"
                textcolor="white"
                label={`EDIÇÃO DO FINANCEIRO: Contrato Nº ${numero}`}
              />
            </Grid>
          </Header>
        </DialogTitle>
        <DialogContent style={{ overflowY: "unset" }}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
          >
            <Grid item xs={8} container spacing={2}>
              <Grid item xs={2}>
                <SelectErp
                  error={false}
                  loading={false}
                  label="Situação"
                  value={situation}
                  setValue={setSituation}
                  optionsList={listSituation}
                  descriptionField="label"
                  variant="standard"
                />
              </Grid>
              <Grid item xs={2}>
                <Tooltip title="Buscar por data de Vencimento">
                  <TextFieldErp
                    label="Data Inicial"
                    variant="standard"
                    type="date"
                    size="small"
                    setValue={setInitialFilterDate}
                    value={initialFilterDate}
                  />
                </Tooltip>
              </Grid>

              <Grid item xs={1} container justifyContent="center">
                <Btn
                  onClick={() => handleClear()}
                  startIcon={<BrushSharp />}
                  hovercolor="orange"
                />
              </Grid>

              <Grid item xs={2}>
                <Tooltip title="Buscar por data de Vencimento">
                  <TextFieldErp
                    label="Data Final"
                    variant="standard"
                    type="date"
                    size="small"
                    setValue={setFinalFilterDate}
                    value={finalFilterDate}
                  />
                </Tooltip>
              </Grid>
              <Grid item>
                <Btn
                  label="Filtrar"
                  onClick={() => {
                    setCrRows([]);
                    getContasReceberByContract(
                      id,
                      setCrRows,
                      setLoading,
                      situation?.value,
                      initialFilterDate,
                      finalFilterDate
                    );
                  }}
                  endIcon={<FilterListIcon />}
                  bgcolor="primary"
                  hovercolor="orange"
                  full="true"
                />
              </Grid>
              <TableDefault
                maxHeight="100vh"
                disabledDefaultPagination
                disabledEmptySpace
                fullWidth
                selectable
                orderSort="asc"
                selectedByRow={false}
                columns={[
                  {
                    id: "acoes",
                    label: "Ações",
                    align: "center",
                    format: (item) => (
                      <SpeedDialErp
                        actions={[
                          {
                            icon: <EditOutlined />,
                            name: "Editar Operações",
                            action: () => editViewHistoric(item),
                            disabled:
                              item.situacaodocto !==
                              GlobalVariables.RecieveSituations.inWallet,
                          },
                        ]}
                      />
                    ),
                  },
                  {
                    id: "id",
                    label: "ID CR",
                    disablePadding: true,
                  },
                  {
                    id: "numerodocto",
                    label: "Nº",
                  },
                  {
                    id: "situacaoreceber.descricao",
                    label: "Situação",
                    format: (item) => {
                      return item?.situacaoreceber?.descricao;
                    },
                  },
                  {
                    id: "dataemissao",
                    label: "Emissão",
                    format: ({ dataemissao }) =>
                      moment(dataemissao, "YYYY-MM-DD").format("DD/MM/YYYY"),
                  },
                  {
                    id: "mes_competencia",
                    label: "Competência",
                  },
                  {
                    id: "datavencto",
                    label: "Vencimento",
                    format: ({ datavencto }) =>
                      moment(datavencto, "YYYY-MM-DD").format("DD/MM/YYYY"),
                  },
                  {
                    id: "valordocto",
                    label: "Valor",
                    format: ({ valordocto }) =>
                      "R$ " +
                      MaskService.toMask("decimal", valordocto ?? "0.00"),
                  },
                ]}
                rowsPerPage={crRows?.length}
                values={crRows}
                setSelected={setSelectedAccounts}
                selected={selectedAccounts}
              />
            </Grid>
            <Grid item xs={4} container spacing={2}>
              <Grid item xs={12}>
                <InputRadio
                  row
                  label="Selecione a operação"
                  options={[
                    {
                      label: "Abatimento",
                      value: "A",
                    },
                    {
                      label: "Adicionar serviço avulso",
                      value: "add",
                    },
                    {
                      label: "Despesas Reembolsáveis",
                      value: "dp",
                    },
                  ]}
                  value={selectedAction}
                  setValue={setSelectedAction}
                />
              </Grid>
              {/* Renderização dos inputs */}
              {views[selectedAction?.value]}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn
            onClick={() => {
              setOpen(false);
              makeRequestAgain();
            }}
            bgcolor="red"
            hovercolor="darkred"
            label="fechar"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export { ModalEdicaoFinanceiro };
